import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */ './views/Home.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import(/* webpackChunkName: "login" */ './views/Login.vue'),
    },
    {
      path: '/polls',
      name: 'Polls',
      component: () => import(/* webpackChunkName: "polls" */ './views/Polls.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/hazmat',
      name: 'Hazmat',
      component: () => import(/* webpackChunkName: "hazmat" */ './views/Hazmat.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/forum',
      name: 'Forum',
      component: () => import(/* webpackChunkName: "forum" */ './views/Forum.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/maintenance',
      name: 'Maintenance',
      component: () => import(/* webpackChunkName: "maintenance" */ './views/Maintenance.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/council-portal',
      name: 'CouncilPortal',
      component: () => import(/* webpackChunkName: "council-portal" */ './views/CouncilPortal.vue'),
      meta: {
        requiresAuth: true,
      },
      beforeEnter(to, from, next) {
        var password = prompt('Please type the password')
        if (password) {
          return store
            .dispatch('auth/checkUser', {
              username: 'councilportal@episode5.com',
              password,
            })
            .then(() => {
              to.params.from = from
              next({ to })
            })
            .catch(() => next(false))
        }
        next(false)
      },
    },
    {
      path: '/personnel',
      component: () => import(/* webpackChunkName: "personnel" */ './views/Personnel.vue'),
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: '',
          name: 'Personnel',
          component: () =>
            import(/* webpackChunkName: "personnel-home" */ './views/Personnel/PersonnelHome.vue'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'council',
          name: 'CouncilProfiles',
          component: () =>
            import(
              /* webpackChunkName: "personnel-council" */ './views/Personnel/PersonnelCouncilProfiles.vue'
            ),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'resident',
          name: 'ResidentDirectory',
          component: () =>
            import(
              /* webpackChunkName: "personnel-resident" */ './views/Personnel/PersonnelResidentDirectory.vue'
            ),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: Math.random()
            .toString(36)
            .substring(7),
          name: 'Backdoor1',
          component: () =>
            import(
              /* webpackChunkName: "personnel-backdoor" */ './views/Personnel/PersonnelBackdoor.vue'
            ),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: Math.random()
            .toString(36)
            .substring(7),
          name: 'Backdoor2',
          component: () =>
            import(
              /* webpackChunkName: "personnel-backdoor-2" */ './views/Personnel/PersonnelBackdoor2.vue'
            ),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: Math.random()
            .toString(36)
            .substring(7),
          name: 'Backdoor3',
          redirect: { name: 'Backdoor2' },
        },
        {
          path: Math.random()
            .toString(36)
            .substring(7),
          name: 'Backdoor4',
          redirect: { name: 'Backdoor2' },
        },
        {
          path: Math.random()
            .toString(36)
            .substring(7),
          name: 'Backdoor5',
          redirect: { name: 'home', params: { enableDark: true } },
        },
      ],
    },
    {
      path: '/rations',
      component: () => import(/* webpackChunkName: "rations" */ './views/Rations.vue'),
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: '',
          name: 'Rations',
          component: () =>
            import(/* webpackChunkName: "rations-home" */ './views/Rations/RationsHome.vue'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'petition',
          name: 'RationsPetition',
          component: () =>
            import(
              /* webpackChunkName: "rations-petition" */ './views/Rations/RationsPetition.vue'
            ),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'inventory',
          name: 'RationsInventory',
          component: () =>
            import(
              /* webpackChunkName: "rations-inventory" */ './views/Rations/RationsInventory.vue'
            ),
          meta: {
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: '/investigation',
      component: () => import(/* webpackChunkName: "investigation" */ './views/Investigation.vue'),
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: '',
          name: 'Investigation',
          component: () =>
            import(
              /* webpackChunkName: "investigation-home" */ './views/Investigation/InvestigationHome.vue'
            ),
          meta: {
            requiresAuth: true,
            title: '///WINDOW/INVESTIGATION/CASEFILE',
          },
        },
        {
          path: 'perimeter',
          name: 'Perimeter',
          component: () =>
            import(
              /* webpackChunkName: "investigation-perimeter" */ './views/Investigation/InvestigationPerimeter.vue'
            ),
          meta: {
            requiresAuth: true,
            title: '///WINDOW/INVESTIGATION/CASEFILE/perimetercam.jpg',
          },
        },
        {
          path: 'schematics',
          name: 'Schematics',
          component: () =>
            import(
              /* webpackChunkName: "investigation-schematics" */ './views/Investigation/InvestigationSchematics.vue'
            ),
          meta: {
            requiresAuth: true,
            title: '///WINDOW/INVESTIGATION/CASEFILE/ULFSchematics.pdf',
          },
        },
        {
          path: 'entryway',
          name: 'EntryWay',
          component: () =>
            import(
              /* webpackChunkName: "investigation-entryway" */ './views/Investigation/InvestigationEntryWay.vue'
            ),
          meta: {
            requiresAuth: true,
            title: '///WINDOW/INVESTIGATION/CASEFILE/surveillance.Entryway.mp4',
          },
        },
        {
          path: 'dnafiles',
          name: 'DNAFiles',
          component: () =>
            import(
              /* webpackChunkName: "investigation-dnafiles" */ './views/Investigation/InvestigationDNAFiles.vue'
            ),
          meta: {
            requiresAuth: true,
            title: '///WINDOW/INVESTIGATION/CASEFILE/B012DNAFILES',
          },
        },
        {
          path: 'environmental-report',
          name: 'EnvironmentalReport',
          component: () =>
            import(
              /* webpackChunkName: "investigation-environmental-report" */ './views/Investigation/InvestigationEnvironmentalReport.vue'
            ),
          meta: {
            requiresAuth: true,
            title: '///WINDOW/INVESTIGATION/CASEFILE/ENVIRONMENTALREPORT',
          },
        },
        {
          path: 'sustainability-report',
          name: 'SustainabilityReport',
          component: () =>
            import(
              /* webpackChunkName: "investigation-sustainability-report" */ './views/Investigation/InvestigationSustainabilityReport.vue'
            ),
          meta: {
            requiresAuth: true,
            title: '///WINDOW/INVESTIGATION/CASEFILE/SUSTAINABILITYREPORT',
          },
        },
        {
          path: 'state-of-convergence',
          name: 'StateOfConvergence',
          component: () =>
            import(
              /* webpackChunkName: "investigation-state-of-convergence" */ './views/Investigation/InvestigationStateOfConvergence.vue'
            ),
          meta: {
            requiresAuth: true,
            title: '///WINDOW/INVESTIGATION/CASEFILE/STATEOFCONVERGENCE.TXT',
          },
        },
      ],
    },
    {
      path: '/documents',
      component: () => import(/* webpackChunkName: "documents" */ './views/Documents.vue'),
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: '',
          name: 'Documents',
          component: () =>
            import(/* webpackChunkName: "documents-home" */ './views/Documents/DocumentsHome.vue'),
          meta: {
            requiresAuth: true,
            title: '///WINDOW/NOTES/DOCUMENTS',
          },
        },
        {
          path: 'personnel',
          name: 'PersonnelFiles',
          component: () =>
            import(
              /* webpackChunkName: "documents-personnel" */ './views/Documents/DocumentsPersonnelFiles.vue'
            ),
          meta: {
            requiresAuth: true,
            title: '///WINDOW/NOTES/DOCUMENTS/personnelfiles.notes.txt',
          },
        },
        {
          path: 'sermon',
          name: 'Sermon',
          component: () =>
            import(
              /* webpackChunkName: "documents-sermon" */ './views/Documents/DocumentsSermon.vue'
            ),
          meta: {
            requiresAuth: true,
            title: '///WINDOW/NOTES/DOCUMENTS/sermon.txt',
          },
        },
        {
          path: 'n113',
          name: 'N113',
          component: () =>
            import(
              /* webpackChunkName: "documents-sermon" */ './views/Documents/DocumentsN113.vue'
            ),
          meta: {
            requiresAuth: true,
            title: '///WINDOW/NOTES/DOCUMENTS/N113-(61756)-56869A',
          },
        },
        {
          path: 'council-meeting',
          name: 'CouncilMeeting',
          component: () =>
            import(
              /* webpackChunkName: "council-meeting" */ './views/Documents/DocumentsCouncilMeeting.vue'
            ),
          meta: {
            requiresAuth: true,
            title: '///WINDOW/NOTES/DOCUMENTS/Council.MeetingMinutes',
          },
        },
      ],
    },
    {
      path: '/tssfile',
      name: 'TSSFile',
      component: () => import(/* webpackChunkName: "tssfile" */ './views/TSSFile.vue'),
      meta: {
        requiresAuth: true,
        title: '///WINDOW/EXTERNALRECON/TSSFILE.TXT',
      },
    },
    {
      path: '/virusReport',
      name: 'VirusReport',
      component: () => import(/* webpackChunkName: "virus-report" */ './views/VirusReport.vue'),
      meta: {
        requiresAuth: true,
        title: '///WINDOW/EXTERNALRECON/VIRUSREPORT',
      },
    },
    {
      path: '/frequencies',
      name: 'FrequenciesReceived',
      component: () =>
        import(/* webpackChunkName: "Frequencies-received" */ './views/FrequenciesReceived.vue'),
      meta: {
        requiresAuth: true,
        title: '///WINDOW/INTERNALRECON/PATRICIA/SYSTEMACCESSRECORDS',
      },
    },
    {
      path: '/terminal',
      name: 'Terminal',
      component: () => import(/* webpackChunkName: "terminal" */ './views/Terminal.vue'),
      meta: {
        requiresAuth: true,
        episode: 3,
        title: '///window/notes/terminal/Redacted.File.PDF',
      },
      props: true,
    },
    {
      path: Math.random()
        .toString(36)
        .substring(7),
      name: 'TerminalGranted',
      component: () => import(/* webpackChunkName: "terminal-granted" */ './views/Terminal.vue'),
      meta: {
        requiresAuth: true,
        episode: 3,
        title: '///window/notes/terminal/the_oswald_file',
      },
      props: true,
    },
    {
      path: '/facility',
      component: () => import(/* webpackChunkName: "facility" */ './views/Facility.vue'),
      meta: {
        requiresAuth: true,
        episode: 3,
      },
      children: [
        {
          path: '',
          name: 'Facility',
          component: () =>
            import(
              /* webpackChunkName: "facility-content" */ './views/Facility/FacilityContent.vue'
            ),
          meta: {
            requiresAuth: true,
            episode: 3,
            title: '///WINDOW/INTERNALRECON/FACILITYMAP',
          },
        },
        {
          path: 'room105A',
          name: 'Room105A',
          component: () =>
            import(
              /* webpackChunkName: "facility-room105a" */ './views/Facility/FacilityRoom105A.vue'
            ),
          meta: {
            requiresAuth: true,
            episode: 3,
            title: '///WINDOW/INTERNALRECON/FACILITYMAP/Surveillance.Dormitory105A.live',
          },
          beforeEnter(to, from, next) {
            var password = prompt('Please type the password')
            if (password) {
              return store
                .dispatch('auth/checkUser', {
                  username: 'room105a@episode3.com',
                  password: `room${password}`,
                })
                .then(() => {
                  to.params.from = from
                  next({ to })
                })
                .catch(() => next(false))
            }
            next(false)
          },
        },
      ],
    },
    {
      path: '/comunication',
      component: () => import(/* webpackChunkName: "comunication" */ './views/Comunication.vue'),
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: '',
          name: 'Communication',
          component: () =>
            import(
              /* webpackChunkName: "comunication-home" */ './views/Comunication/ComunicationHome.vue'
            ),
          meta: {
            requiresAuth: true,
            title: '///WINDOW/COMMUNICATION',
          },
        },
        {
          path: 'readme',
          name: 'CommunicationReadme',
          component: () =>
            import(/* webpackChunkName: "comunication-readme" */ './views/Comunication/Readme.vue'),
          meta: {
            requiresAuth: true,
            title: '///WINDOW/COMMUNICATION/README.TXT',
          },
        },
        {
          path: 'email-chain',
          name: 'A001EmailChain',
          component: () =>
            import(
              /* webpackChunkName: "comunication-email-chain" */ './views/Comunication/A001EmailChain.vue'
            ),
          meta: {
            requiresAuth: true,
            title: '////WINDOW.COMMUNICATION.A001.EmailChain.txt',
          },
        },
        {
          path: 'failsafe-restricted',
          name: 'FailsafeRestricted',
          component: () =>
            import(
              /* webpackChunkName: "comunication-failsafe-restricted" */ './views/Comunication/ComunicationFailsafeRestricted.vue'
            ),
          meta: {
            requiresAuth: true,
            title: '///WINDOW/COMMUNICATION/FAILSAFE.RESTRICTED',
          },
          beforeEnter(to, from, next) {
            var password = prompt('Please type the password')
            if (password) {
              return store
                .dispatch('auth/checkUser', {
                  username: 'failsafe@episode5.com',
                  password,
                })
                .then(() => {
                  to.params.from = from
                  next({ to })
                })
                .catch(() => next(false))
            }
            next(false)
          },
        },
      ],
    },
  ],
})

router.beforeEach((to, from, next) => {
  if (to.params.enableDark) {
    store.dispatch('auth/enableDarkSide')
  }
  const loggedIn = !!store.state.auth.user
  const { requiresAuth } = to.meta

  if (requiresAuth && !loggedIn) {
    next('login')
  } else if (!requiresAuth && loggedIn) {
    next('/')
  } else {
    next()
  }
})

export default router
